import styled from "styled-components";
import { theme } from "../../../config";
import { Button } from "../../atoms/Button";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 15px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const BodyWrapper = styled.div`
  background-color: ${theme.colors.white};
  padding: 20px;
  border-radius: 8px;
  ${theme.defaultBoxShadow}
  &:first-child {
    visibility: hidden;
  }

  .calendar-title {
    font-family: "Orkney Bold";
  }

  .css-190p05k-Event::after,
  .css-18i2ql3::after {
    content: "| ";
  }

  .tooltip {
    padding: 16px 16px 24px 16px;
    width: 304px;
  }

  .tooltip-text {
    padding: 11px 10% 0px 15px;
    line-height: 24px;
    font-weight: bold;
    font-size: 20px;
  }

  .display-linebreak {
    font-size: 14px;
  }

  .description {
    padding: 0px 8% 0px 15px;
  }

  .calendarName,
  .css-xaf3ee-Tooltip,
  .css-f0505d,
  .display-linebreak,
  .css-u3cpw5-render {
    padding: 0px 10% 0px 15px;
  }

  .css-xaf3ee-Tooltip,
  .css-f0505d,
  .css-u3cpw5-render {
    color: ${theme.colors.secondary};
    font-weight: bolder;
    font-size: 14px;
    letter-spacing: 0px;
  }
`;

export const LoaderWrapper = styled.div`
  justify-content: center;
  text-align: center;
`;

export const CalendarWrapper = styled.div<{ showCalendar: boolean }>`
  display: ${(props) => (props.showCalendar ? "inline" : "none")};
`;

export const DateWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;

  .ant-picker-clear {
    display: none;
  }
`;
export const ButtonStyled = styled(Button)`
  background: ${theme.colors.secondary};
  color: ${theme.colors.white};
  padding: 0 5px 0 5px;
  margin-left: 9px;
`;
